<template>
    <div id="page">
        <div class="info">
            {{ $t('notallowed.info') }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotAllowedPage'
}
</script>

<style scoped>
#page {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.info {
    font-weight: bold;
    font-size: 2em;
    height: fit-content;
    color: red;
    max-width: 90%;
}
</style>